import { render, staticRenderFns } from "./acceptList.vue?vue&type=template&id=65629378&scoped=true&"
import script from "./acceptList.vue?vue&type=script&lang=js&"
export * from "./acceptList.vue?vue&type=script&lang=js&"
import style0 from "./acceptList.vue?vue&type=style&index=0&id=65629378&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65629378",
  null
  
)

export default component.exports